import { Helmet } from "react-helmet-async";
import React from "react";
export const SchemaLocalBusiness = _ref => {
  let {
    image,
    logo
  } = _ref;
  return /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify({
    "@context": "http://schema.org",
    "@type": "LocalBusiness",
    name: "Miscusi",
    alternateName: "Mi scusi",
    url: "https://www.miscusi.com",
    image: "".concat(image),
    logo: "".concat(logo),
    sameAs: ["https://www.facebook.com/miscusi.official/", "https://www.instagram.com/miscusi.family/"],
    vatID: "IT09677510969"
  })));
};